import { defaultUrlTransform } from "react-markdown";

const LINK_PROTOCOLS = new Set(["http", "https", "mailto", "tel"]);
const IMAGE_PROTOCOLS = new Set(["http", "https"]);
const SCHEME = /^([a-z][a-z0-9+.-]*):/i;

function hasAsciiControl(value: string) {
  return Array.from(value).some((character) => {
    const codePoint = character.codePointAt(0) ?? 0;
    return codePoint <= 31 || codePoint === 127;
  });
}

/**
 * 只允许明确的 Web/通信协议或站内相对地址。
 *
 * React Markdown 自带安全 URL 转换；这里在它之前增加 HerSkin 的显式白名单，
 * 同时拒绝协议相对 URL、反斜杠网络路径和利用空白拆分的危险 scheme。
 */
export function safeUrlTransform(url: string, key: string): string {
  if (hasAsciiControl(url)) return "";

  const candidate = url.trim();
  if (!candidate || candidate.startsWith("//") || candidate.startsWith("\\")) {
    return "";
  }

  const colonIndex = candidate.indexOf(":");
  if (colonIndex >= 0) {
    const compactScheme = candidate.slice(0, colonIndex + 1).replace(/\s+/g, "");
    const match = SCHEME.exec(compactScheme);

    if (!match) return "";

    const protocol = match[1]!.toLowerCase();
    const allowed = key === "src" ? IMAGE_PROTOCOLS : LINK_PROTOCOLS;
    if (!allowed.has(protocol)) return "";
  }

  return defaultUrlTransform(candidate);
}

export function isExternalHttpUrl(url: string | undefined): boolean {
  return /^https?:\/\//i.test(url ?? "");
}
